var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilledStarOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Filled Star 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.698 2.41575L8.1495 7.60822L2.45082 8.44087C1.25708 8.61529 0.780429 10.0904 1.64422 10.937L5.76783 14.9788L4.79438 20.6859C4.59046 21.8814 5.83836 22.7931 6.90607 22.2286L12.0031 19.5341L17.1002 22.2286C18.1679 22.7931 19.4158 21.8814 19.2119 20.6859L18.2384 14.9788L22.362 10.937C23.2258 10.0904 22.7492 8.61529 21.5554 8.44087L15.8567 7.60822L13.3082 2.41575C12.7744 1.32805 11.2319 1.32805 10.698 2.41575Z",
    fill: "#FF6600"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilledStarOrange);
export default __webpack_public_path__ + "static/media/icon-filled-star-orange.66c9a724ba421f217ca6d4216834a4ca.svg";
export { ForwardRef as ReactComponent };